
































































































import Vue from 'vue'
import { mapState } from 'vuex'
import { fc3MainHostname } from '@/helpers/constants'
import { fc3ModHostname } from '@/helpers/constants'

// svgs
import AlertsIcon from '@/assets/alerts.svg'
import FreecycleLogo from '@/assets/logo.svg'
import MainLink from '@/assets/main.svg'
import MessagesIcon from '@/assets/messages.svg'
import ProfileIcon from '@/assets/profile.svg'
import resetStore from '@/helpers/vuexReset'
import wsClient from '@/helpers/wsClient'

export default Vue.extend({
  name: 'Top',
  props: ['towns'],

  components: {
    AlertsIcon,
    FreecycleLogo,
    MainLink,
    MessagesIcon,
    ProfileIcon
  },

  mounted() {
    this.initDropdowns()
  },

  destroyed() {
    this.initDropdowns('remove')
  },

  data() {
    return {
      fc3MainHostname,
      fc3ModHostname,
      menuItems: [
        {
          path: '/home/dashboard/',
          name: 'My Dashboard'
        },
        {
          path: '/home/my-replies/',
          name: 'My Messages'
        },
        {
          path: '/home/my-posts/',
          name: 'My Posts'
        },
        {
          path: '/home/my-towns/',
          name: 'My Towns'
        },
        {
          path: '/home/my-friends/',
          name: 'My Friends'
        },
        {
          path: '/home/settings/',
          name: 'My Settings'
        }
      ]
    }
  },

  methods: {
    initDropdowns(action = 'add') {
      const menus = document.querySelectorAll('.custom-dropdown.menu')
      for(const [_, menu] of menus.entries()) {

        let trigger = menu.querySelector('.custom-dropdown-toggle')
        if(trigger !== null) {
          if(action === 'add') {
            trigger.addEventListener('click', (e) => menu.classList.toggle('active'))
          } else {
            trigger.removeEventListener('click', (e) => menu.classList.toggle('active'))
          }
        }
      }
    },
    logout() {
      resetStore()
      wsClient.close()
      window.location.href = `https://${fc3MainHostname}${'/logout'}`
    }
  }
})
